import { ScrollableView } from "@remo-co/ui-core/src/components/ScrollableView";
import { Block } from "@remo-co/ui-core/src/icons/Block";
import { BlurOn } from "@remo-co/ui-core/src/icons/BlurOn";
import { MoreHoriz } from "@remo-co/ui-core/src/icons/MoreHoriz";
import { useI18n } from "i18n";
import { Fragment, useMemo } from "react";
import { useDevices } from "modules/audioVideo/hooks/useDevices";
import {
  useVirtualBackground,
  useBackgroundImageQuery,
} from "../../../hooks/useVirtualBackground";
import { VirtualBackgrounds } from "../../../constants";
import { useStyles } from "../styles";
import { MenuButton, ImageButton, UploadImageButton } from "./Buttons";

export const VirtualBackgroundMenu = () => {
  const {
    backgroundImages,
    endOfPagination,
    isLoadingBackgroundImages,
    fetchMoreBackgroundImages,
  } = useBackgroundImageQuery();

  const { activeDevices } = useDevices();

  const { t } = useI18n(["event", "common", "videoBackground"]);
  const styles = useStyles();
  const {
    isLoading: isLoadingVirtualBackground,
    setVirtualBackground,
    currentBackground,
  } = useVirtualBackground();

  const onBackgroundImageClick = (url: string) => {
    setVirtualBackground({ type: VirtualBackgrounds.IMAGE, url });
  };

  const disabled = useMemo(
    () => activeDevices.videoInput === null || isLoadingVirtualBackground,
    [activeDevices.videoInput, isLoadingVirtualBackground],
  );

  return (
    <ScrollableView
      className={styles.backgroundMenu}
      data-testid="virtual-background"
    >
      <MenuButton
        disabled={
          disabled || currentBackground.type === VirtualBackgrounds.NONE
        }
        icon={<Block />}
        label={t("videoBackground:text.no.background")}
        onClick={() => {
          setVirtualBackground({ type: VirtualBackgrounds.NONE });
        }}
      />
      <UploadImageButton />
      <MenuButton
        disabled={
          disabled || currentBackground.type === VirtualBackgrounds.BLUR
        }
        icon={<BlurOn />}
        label={t("videoBackground:blur")}
        onClick={() => {
          setVirtualBackground({ type: VirtualBackgrounds.BLUR });
        }}
      />
      {backgroundImages.map((group) => (
        <Fragment key={group.map((image) => image.id).join("")}>
          {group.map((image) => (
            <ImageButton
              loading={isLoadingBackgroundImages}
              key={image.id}
              url={image.url}
              disabled={
                disabled ||
                (currentBackground.type === VirtualBackgrounds.IMAGE &&
                  currentBackground.url === image.url)
              }
              onClick={() => onBackgroundImageClick(image.url)}
            />
          ))}
        </Fragment>
      ))}
      <MenuButton
        disabled={endOfPagination}
        loading={isLoadingBackgroundImages}
        icon={<MoreHoriz />}
        label={t("event:load.more")}
        onClick={() => {
          fetchMoreBackgroundImages();
        }}
      />
    </ScrollableView>
  );
};
